import {BaseUserFlow, UserFlowStep, UserFlowList} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';

export class UpgradeUserFlow extends BaseUserFlow {
  protected readonly type = UserFlowType.Upgrade;

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    return [`${this.type}.${UserFlowStep.Upgrade}`];
  }
}
